import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-layout-tree-selected",
  "use": "app-icon-layout-tree-selected-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"app-icon-layout-tree-selected\"><g fill=\"none\" fill-rule=\"evenodd\"><rect fill=\"#6C92FA\" fill-rule=\"nonzero\" width=\"32\" height=\"32\" rx=\"1\" /><g stroke=\"#FFF\" stroke-width=\"1.5\"><path d=\"M14 7.5v3h-3v-3zM22.5 21v3h-3v-3zM22.5 13.5v3h-3v-3zM19.5 15h-7v7.619h7M12.5 15.5v-5\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol